import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import Select from 'react-select';

import { _post } from '../../../utils/network';
import { toEnglishDigits } from '../../../utils/methods';

const USERS_COUNT = 20;
const SEARCH_DEBOUNCE_MS = 500;

const toOption = user => ({
	value: user.user_id,
	label: `${user.user_fullname || '-'} - ${user.phone_number || '-'}`
});

/** Searchable user picker: shows the newest users by default and queries the server by name or mobile as the admin types. */
const UserSearchSelect = ({ fieldKey, title, value, onChange, isSearch = true }) => {
	const { t } = useTranslation();
	const [query, setQuery] = useState('');
	const [debouncedQuery, setDebouncedQuery] = useState('');
	const [options, setOptions] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const requestIdRef = useRef(0);

	useEffect(() => {
		const timer = setTimeout(() => setDebouncedQuery(query.trim()), SEARCH_DEBOUNCE_MS);
		return () => clearTimeout(timer);
	}, [query]);

	useEffect(() => {
		const getUsers = async () => {
			const term = toEnglishDigits(debouncedQuery);
			const isMobile = /^\d+$/.test(term);
			const body = {
				user_fullname: term && !isMobile ? term : null,
				phone_number: term && isMobile ? term : null,
				national_code: null,
				trade_code: null,
				inviter_code: null,
				is_credit: null,
				is_active: null,
				page: 1,
				count: USERS_COUNT
			};
			const requestId = ++requestIdRef.current;
			setIsLoading(true);
			const response = await _post('/users/admin/getAll', body);
			if(requestId !== requestIdRef.current)
				return;
			setIsLoading(false);
			switch(response.code){
				case 200:
					setOptions(response.data.users.map(toOption));
					break;
				default:
					toast.error(response[t('api_message')]);
			}
		};
		getUsers();
	}, [debouncedQuery]);

	return (
		<div className={(isSearch ? "col-sm-6 col-md-4" : "col-md-6") + " mb-3"}>
			<label className="form-check-label" htmlFor={fieldKey}>{title}</label>
			<Select
				inputId={fieldKey}
				placeholder={t('all')}
				options={options}
				value={value}
				isClearable
				isLoading={isLoading}
				filterOption={null}
				noOptionsMessage={() => t('no_results')}
				onInputChange={input => setQuery(input)}
				onChange={option => onChange(option || null)}
			/>
		</div>
	);
};

export default UserSearchSelect;
